import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const SWEDEN_DATABASE_COUNTRY_ID = 7;

export const SwedenCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.SWEDEN,
  languageCode: ELanguageCode.SWEDISH,
  country: ECountry.SWEDEN,
  phoneAllowed: true,
  addressAllowed: true,
  phone: {
    mask: "+46 99999999?9",
    placeholder: "+46 99 999 99 99",
    prefix: "+46",
  },
  databaseCountryId: SWEDEN_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
